import React, {useEffect} from 'react';
import {Route, Routes} from 'react-router-dom';
import './App.scss';
import {Banner} from './banner/Banner';
import {CheatSheet} from './cheatsheet/CheatSheet';
import {CookiePanel} from './cookie/CookiePanel';
import {Docker} from './Docker';
import {Base64} from './format/Base64';
import {DataFormat} from './format/DataFormat';
import {GameReview} from './gamereview/GameReview';
import {Header} from './Header';
import {Home} from './Home';
import bgimg from './images/matrix_1920.jpg';
import {Security} from './Security';
import {SupportUkraine} from './support_ukraine/SupportUkraine';
import {Template} from './template/Template';

var WebFont = require('webfontloader');

function App() {
    useEffect(() => {
        WebFont.load({
            google: {
                families: [
                    'Space Mono',
                    'Indie Flower',
                    'Lobster',
                    'Caveat',
                    'Share Tech Mono',
                ],
            },
        });
    }, []);
    // const allowSite = useAllowSite();
    // if (allowSite()) {
    return (<>
            <div className='App'>
                <Header/>
                <CookiePanel/>
                <img src={bgimg} className='first_image' alt='Matrix Image'/>
                <div className='content'>
                    <Routes>
                        <Route path='/' element={<Home/>}/>
                        <Route path='/base64' element={<Base64/>}/>
                        <Route path='/security' element={<Security/>}/>
                        <Route path='/docker' element={<Docker/>}/>
                        <Route path='/banner' element={<Banner/>}/>
                        <Route path='/data-format' element={<DataFormat/>}/>
                        <Route path='/cheat-sheets' element={<CheatSheet/>}/>
                        <Route path='/game-reviews' element={<GameReview/>}/>
                        <Route path='/ukraine' element={<SupportUkraine/>}/>
                        <Route path='/ukraine' element={<SupportUkraine/>}/>
                        <Route path='/templates' element={<Template/>}/>
                        {/* <Route path='/base' element={<BaseEncoding />} /> */}
                    </Routes>
                </div>
            </div>
        </>
    );

}

export default App;
